import type { ListingRef } from './listings';
import type { PersonRef } from './people';

export type MessagingEligibility = { canMessage: boolean };

export type ConversationKind = 'direct' | 'group';

export type ConversationSummary = {
  id: string;
  kind: ConversationKind;
  name: string | null;
  otherPeople: PersonRef[];
  listing: ListingRef | null;
  lastMessagePreview: string | null;
  lastMessageAt: string | null;
  hasUnread: boolean;
  canSend: boolean;
};

export type MessagePhoto = {
  id: string;
  url: string;
  width: number | null;
  height: number | null;
  mimeType: string;
};

export type Message = {
  id: string;
  kind: 'user' | 'system';
  sender: PersonRef | null;
  body: string;
  photos: MessagePhoto[];
  sentAt: string;
  removed: boolean;
  isCollapsed: boolean;
};

/**
 * One conversation, with the messages I may read and what I may do in it now.
 * The four flags are the server's; all false on a direct conversation.
 */
export type Conversation = ConversationSummary & {
  messages: Message[];
  canAddPeople: boolean;
  canRename: boolean;
  canRemovePeople: boolean;
  canLeave: boolean;
};

/** The longest message or comment the service accepts (today's limit). */
export const MAX_MESSAGE_LENGTH = 3000;

export type NewMessage = { body: string | null; photoIds: string[]; idempotencyKey: string | null };

/** Where a message photo goes before it's confirmed. */
export type MessagePhotoUpload = { imageId: string; blobName: string; uploadUrl: string };
